import graphql__3098c9f3dde6f57437be from "./__generated__/AnswerString_answer.graphql.js";import { graphql, useFragment } from "react-relay";

import { useReadOnlyFieldProps } from "./useReadOnlyFieldProps";
import StringField from "../Form/Field/StringField";

const AnswerString = props => {
  const { content, formField } = useFragment(AnswerString_answer, props.answer);
  const { fieldName, label, required, hint, hintPosition, autoComplete } = formField;
  const { hide, disabled } = useReadOnlyFieldProps(formField);
  const { parent } = props;

  return (
    <StringField
      required={required}
      fieldName={fieldName}
      label={label}
      hint={hint}
      hintPosition={hintPosition}
      hide={hide}
      disabled={disabled}
      parent={parent}
      defaultValue={content}
      autoComplete={autoComplete}
    />
  );
};

const AnswerString_answer = graphql__3098c9f3dde6f57437be;

export default AnswerString;
